module.exports = __webpack_public_path__ + "static/boldfloralonesie-eabafc59a1d1b9727306154b82efaa48.jpeg";